module.exports = __webpack_public_path__ + "media/customizations/avemariamaster/logo-new-e7423d62fdc51322f564e4a6d60f5744.png";